<div @fadeInUpAnimation class="signup-left">
  <ng-content select="[left-side]"></ng-content>
</div>

<div *ngIf="!(isMobile$ | async)" @fadeInUpAnimation class="signup-right">
  <ng-content select="[right-side]"></ng-content>
</div>
